/**
 * Returns a new object with all keys of the given object transformed to lower case (first letter only).
 * @param {Object} object
 * @return {Object}
 */
export function getObjectWithLowerCaseKeys(object) {
    if (!(object instanceof Object)) {
        throw Error('Expected object, but got: ' + object);
    }

    const lowerCaseObj = {};

    Object.keys(object).forEach(key => {
        const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
        lowerCaseObj[lowerCaseKey] = object[key];
    });

    return lowerCaseObj;
}

/**
 * Returns a new object with all keys of the given object transformed to capitalized keys.
 * @param {Object} object
 * @return {Object}
 */
export function getObjectWithCapitalizedKeys(object) {
    if (!(object instanceof Object)) {
        throw Error('Expected object, but got: ' + object);
    }

    const upperCaseObj = {};

    Object.keys(object).forEach(key => {
        const lowerCaseKey = key.charAt(0).toUpperCase() + key.slice(1);
        upperCaseObj[lowerCaseKey] = object[key];
    });

    return upperCaseObj;
}